import type { FC, ReactNode } from "react";
import { SimpleMenu } from "../Menu/simpleMenu.js";
import { SimpleMenuItem } from "../Menu/simpleMenuItem.js";
import { SimpleMenuPopover } from "../Menu/simpleMenuPopover.js";

export interface DropdownItem {
  icon?: ReactNode;
  label: string;
  onClick: () => void;
}

interface DropdownMenuProps {
  items: DropdownItem[];
  align?: "left" | "right";
  position?: "top" | "bottom";
}

export const DropdownMenu: FC<DropdownMenuProps> = ({
  items,
  align = "right",
  position = "bottom",
}) => {
  return (
    <SimpleMenuPopover placement={`${position} ${align}`}>
      <SimpleMenu aria-label="Menu">
        {items.map((i) => (
          <SimpleMenuItem key={`dropdown-item-${i.label}`} onAction={i.onClick}>
            <span className="flex items-center gap-x-2">
              {i.icon}
              {i.label}
            </span>
          </SimpleMenuItem>
        ))}
      </SimpleMenu>
    </SimpleMenuPopover>
  );
};
